import formatTime from "../hooks/formatTime";
type RenderBoardLogoProps = {
  isGameStarted: boolean;
  time: number;
  isTimerRunning: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
type BoardButtonProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
const BoardButton = ({
  isGameStarted,
  isGameFinished,
  onStart,
  onNext,
}: BoardButtonProps) => {
  if (!isGameStarted) {
    return (
      <button
        title="Начать игру"
        className="transpos-buttonCheck"
        onClick={() => {
          onStart();
        }}
      >
        Начать игру
        <img
          alt=""
          className="transpos-logoRun"
          src="/img/button/run-fix.svg"
        />
      </button>
    );
  }

  if (isGameFinished) {
    return (
      <button className="tableS-buttonCheck" onClick={onNext}>
        Играть ещё
        <img alt="" className="tableS-logoRun" src="/img/button/run-fix.svg" />
      </button>
    );
  }
  return null;
};
const RenderBoardLogo: React.FC<RenderBoardLogoProps> = ({
  isGameStarted,
  time,
  isTimerRunning,
  isGameFinished,
  onNext,
  onStart,
}) => {
  return (
    <div className="transpos-board-logo">
      <img
        alt="logo"
        src="/img/transpos/person-transpos.svg"
        className="transpos-board-logo-image"
      ></img>

      <p className="transpos-subtitle" id="transpos-subtitle-board-logo">
        {isGameStarted && `Таймер: ${formatTime(time)}`}
      </p>
      <div id="transpos-board-logo-button">
        {!isTimerRunning && (
          <BoardButton
            isGameStarted={isGameStarted}
            isGameFinished={isGameFinished}
            onStart={onStart}
            onNext={onNext}
          />
        )}
      </div>
    </div>
  );
};
export default RenderBoardLogo;
